import { createRouter, createWebHashHistory } from 'vue-router'
import store from '../store'

// 路由配置
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录', public: true }
  },
  {
    path: '/password-reset',
    name: 'PasswordReset',
    component: () => import('@/views/password-reset/index.vue'),
    meta: { title: '修改密码' }
  },
  {
    path: '/',
    component: () => import('@/framework/layout/index.vue'),
    redirect: '/device',
    children: [
      {
        path: 'device',
        name: 'Device',
        component: () => import('@/views/device/index.vue'),
        meta: { title: '设备管理' }
      },
      {
        path: 'area',
        name: 'Area',
        component: () => import('@/views/area/index.vue'),
        meta: { title: '区域管理' }
      },
      {
        path: 'user',
        name: 'User',
        component: () => import('@/views/user/index.vue'),
        meta: { title: '用户管理' }
      },
      {
        path: 'device/run-status',
        name: 'DeviceRunStatus',
        component: () => import('@/views/device/run-status.vue'),
        meta: { title: '设备运行状态' }
      },
      {
        path: 'version/firmware',
        name: 'VersionFirmware',
        component: () => import('@/views/version/firmware.vue'),
        meta: { title: '固件管理' }
      },
      {
        path: 'version/app',
        name: 'VersionApp',
        component: () => import('@/views/version/app.vue'),
        meta: { title: 'App版本管理' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = `${to.meta.title} - Motor Control Admin`
  }

  // 公开路由直接放行
  if (to.meta.public) {
    next()
    return
  }

  // 检查登录状态
  const token = localStorage.getItem('token')
  if (!token) {
    next({ name: 'Login', query: { redirect: to.fullPath } })
    return
  }

  next()
})

export default router
